import config from 'config';
import isNil from 'lodash/isNil';
import { isPreviewDomainForSignIn } from 'utils/isPreviewDomainForSignIn';

const getSignInHref = (path: string | null = null) => {
  // Use local sign-in when on a non-surfline.com domain (e.g. Cloudflare Container previews)
  const useLocal = isPreviewDomainForSignIn() || config.signInUrl.startsWith('/');
  const base = useLocal
    ? config.signInUrl.startsWith('/')
      ? config.signInUrl
      : '/sign-in'
    : config.signInUrl;
  if (isNil(path) || path === '/') return base;
  const redirectUrl = useLocal ? path : `${config.surflineHost}${path}`;
  return `${base}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
};

export default getSignInHref;
